


































































import {Component, Ref, Vue} from "vue-property-decorator";
import {Action} from "vuex-class";
import {InputWings, SelectWings, TextareaWings} from "wings-ui-components";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {WhiteListItem} from "@/store/settings/white_list/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({components: {SelectWings, InputWings, TextareaWings}})
export default class WhiteList extends Vue {
  @Action("getWhiteListsItem") actionGetItem: any;
  @Action("saveWhiteList") actionSave: any;
  @Action("deleteWhiteList") actionDelete: any;
  @Action("actionLog") actionLog: any;
  @Ref('validator') validator: any;

  private item: WhiteListItem = Object.create({})
  private itemSaved: WhiteListItem = Object.create({})
  private logObject: ActionLog = {};

  async created() {
    if (this.$route.params.id) {
      try {
        const data = await this.actionGetItem(this.$route.params.id);
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Contact",
          addititional_info: getTranslatedParams({id: data.id})
        }
        await this.actionLog(this.logObject);
        this.item = Object.assign({},this.item, data);
        this.itemSaved = cloneDeep(Object.assign({},this.item, data));
      } catch (err) {
        await this.actionLog({...this.logObject, action_status: 'failed'})
      }
    }
  }

  back(): void {
    this.$router.push(`/settings/white_lists`);
  }

  async onSaveItem(): Promise<void> {
    let valid: boolean = await this.validator.validate();
    if (valid) {
      try {
        const object = {
          id: this.$route.params.id,
          item: this.item
        }
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: this.$route.params.id ? "Editing" : "Creation",
          action_status: "success",
          object_type: "Contact",
          addititional_info: getTranslatedParams(this.item)
        }
        await this.actionSave(object);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
        throw error;
      }
    } else {
      setTimeout(() => {
        notifyError(null, this.validator.errors)
      }, 100);
    }
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Contact",
          addititional_info: getTranslatedParams({id: this.$route.params.id, general: this.item.msisdn})
        }
        const object = {
          id: this.$route.params.id,
          item: this.item
        }
        await this.actionDelete(object);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }
}
